
import React, { useState, useEffect } from "react";
import { Card, Button, Spin, Alert } from "antd";
import { useNavigate } from "react-router-dom";
import { ShoppingCartOutlined } from "@ant-design/icons";
import courseService from "../../services/course.service";
import authHeader from "../../services/auth-header"; // Importez authHeader pour les headers d'authentification
import API_BASE from "../../config/apiConfig";


const API_BASE_URL = `${API_BASE}/images/proxy`; // Crée une URL dynamique basée sur la configuration


const MyPurchases = () => {
    const navigate = useNavigate();
    const [purchases, setPurchases] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const imageCache = {}; // Cache des images pour éviter les répétitions

    // Fonction pour récupérer l'image via le proxy
    const fetchImage = async (imageUrl) => {
        try {
            const response = await fetch(
                // `https://glistening-dedication-production.up.railway.app/api/images/proxy?url=${encodeURIComponent(imageUrl)}`,
                // `http://localhost:8080/api/images/proxy?url=${encodeURIComponent(imageUrl)}`,
                `${API_BASE_URL}?url=${encodeURIComponent(imageUrl)}`,


                {
                    headers: authHeader(),
                }
            );
            if (!response.ok) {
                throw new Error("Erreur lors de la récupération de l'image");
            }
            const blob = await response.blob();
            return URL.createObjectURL(blob); // Convertir l'image en URL locale
        } catch (error) {
            console.error("Erreur lors de la récupération de l'image :", error);
            return "/default-image.png"; // Retourner une image par défaut en cas d'erreur
        }
    };

    // Utiliser useEffect pour récupérer les cours
    useEffect(() => {
        const fetchCourses = async () => {
            try {
                // Récupérer les cours via l'API
                const response = await courseService.getCoursesByModerator(1);

                // Télécharger et transformer les images
                const updatedCourses = await Promise.all(
                    response.map(async (course) => {
                        if (course.image && !imageCache[course.image]) {
                            const imageUrl = await fetchImage(course.image);
                            imageCache[course.image] = imageUrl; // Mise en cache de l'image
                            return { ...course, imageUrl };
                        }
                        return { ...course, imageUrl: imageCache[course.image] || "/default-image.png" };
                    })
                );

                setPurchases(updatedCourses); // Mettre à jour les cours dans l'état
            } catch (err) {
                setError("Impossible de récupérer les cours.");
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchCourses();
    }, []); // Le tableau de dépendances est vide pour exécuter le hook une seule fois

    // Affichage du loader si en cours de chargement
    if (loading) {
        return <Spin size="large" style={{ display: "block", margin: "auto" }} />;
    }

    // Affichage d'une alerte si une erreur survient
    if (error) {
        return <Alert message="Erreur" description={error} type="error" showIcon />;
    }

    return (
        <div className="my-purchases-container" style={{ padding: "20px" }}>
            <h2 style={{ textAlign: "center", marginBottom: "30px", color: "#4A90E2" }}>
                Mes Achats
            </h2>
            <div
                className="purchases-list"
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "20px",
                    justifyContent: "center",
                }}
            >
                {purchases.map((purchase) => (
                    <Card
                        key={purchase.id}
                        hoverable
                        style={{
                            width: "300px",
                            borderRadius: "10px",
                            overflow: "hidden",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            border: "1px solid #e0e0e0",
                        }}
                        cover={
                            <div
                                style={{
                                    height: "180px",
                                    overflow: "hidden",
                                    borderBottom: "1px solid #e0e0e0",
                                }}
                            >
                                <img
                                    alt={purchase.title}
                                    src={purchase.imageUrl || "/default-image.png"}
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        transition: "transform 0.3s",
                                    }}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = "/default-image.png"; // Image par défaut si l'image échoue
                                    }}
                                />
                            </div>
                        }
                    >
                        <Card.Meta
                            title={<span style={{ fontWeight: "bold" }}>{purchase.title}</span>}
                            description={
                                <div>
                                    <p style={{ marginBottom: "8px" }}>
                                        <strong>Prix :</strong> {purchase.latest_price || "Non spécifié"}
                                    </p>
                                    <p style={{ marginBottom: "0" }}>
                                        <strong>Leçons :</strong> {purchase.lessons || "Inconnue"}
                                    </p>
                                </div>
                            }
                        />
                        <Button
                            type="primary"
                            style={{
                                marginTop: "15px",
                                width: "100%",
                                backgroundColor: "#4A90E2",
                                borderColor: "#4A90E2",
                            }}
                            onClick={() => navigate(`/learning/course/${purchase.id}`)}
                        >
                            <ShoppingCartOutlined /> Voir les détails
                        </Button>
                    </Card>
                ))}
            </div>
        </div>
    );
};

export default MyPurchases;
